(function () {
  "use strict";

  function showCopied(button) {
    var status = button.querySelector("[data-copy-status]");
    if (!status) return;

    window.clearTimeout(button._landingRewardsResetTimer);
    status.textContent = button.getAttribute("data-copied-label") || "COPIED!";
    button.setAttribute("aria-label", "Discount code copied");

    button._landingRewardsResetTimer = window.setTimeout(function () {
      status.textContent = button.getAttribute("data-copy-label") || "COPY CODE";
      button.setAttribute(
        "aria-label",
        "Copy discount code " + (button.getAttribute("data-code") || "")
      );
    }, 1800);
  }

  function legacyCopy(text, button) {
    var input = document.createElement("textarea");
    input.value = text;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.appendChild(input);
    input.select();

    try {
      document.execCommand("copy");
      showCopied(button);
    } finally {
      document.body.removeChild(input);
    }
  }

  function getDownloadFileName(link) {
    var customName = (link.getAttribute("data-download-filename") || "").trim();
    if (customName) return customName;

    try {
      var pathname = new URL(link.href, window.location.href).pathname;
      var fileName = pathname.split("/").pop();
      return decodeURIComponent(fileName || "download");
    } catch (error) {
      return "download";
    }
  }

  function triggerDownload(url, fileName) {
    var download = document.createElement("a");
    download.href = url;
    download.download = fileName;
    download.style.display = "none";
    document.body.appendChild(download);
    download.click();
    document.body.removeChild(download);
  }

  function downloadFile(link) {
    if (link.getAttribute("aria-busy") === "true") return;

    var fileUrl = link.href;
    var fileName = getDownloadFileName(link);
    link.setAttribute("aria-busy", "true");

    fetch(fileUrl, { credentials: "omit", mode: "cors" })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to download file");
        return response.blob();
      })
      .then(function (blob) {
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(blob, fileName);
          return;
        }

        var blobUrl = URL.createObjectURL(blob);
        triggerDownload(blobUrl, fileName);
        window.setTimeout(function () {
          URL.revokeObjectURL(blobUrl);
        }, 5000);
      })
      .catch(function () {
        // If a browser blocks cross-origin fetches, fall back to the file URL.
        triggerDownload(fileUrl, fileName);
      })
      .finally(function () {
        link.removeAttribute("aria-busy");
      });
  }

  document.addEventListener("click", function (event) {
    var downloadLink = event.target.closest("[data-landing-download]");
    if (downloadLink) {
      event.preventDefault();
      downloadFile(downloadLink);
      return;
    }

    var button = event.target.closest("[data-landing-copy-code]");
    if (!button) return;

    var code = button.getAttribute("data-code") || "";
    if (!code) return;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(function () {
        showCopied(button);
      }).catch(function () {
        legacyCopy(code, button);
      });
      return;
    }

    legacyCopy(code, button);
  });
})();
